import { render, staticRenderFns } from "./agreementReview.vue?vue&type=template&id=52a6fd88"
import script from "./agreementReview.vue?vue&type=script&lang=js"
export * from "./agreementReview.vue?vue&type=script&lang=js"
import style0 from "./agreementReview.vue?vue&type=style&index=0&id=52a6fd88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports